import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';

class IssueService extends ServiceCRUD {
  constructor() {
    super('assuntos');
  }
}

export default new IssueService();
